import instance from './header.js'


const request = class {
	constructor(url, arg) {
		this.url = url
		this.arg = arg
	}

	// post
	post() {
		return new Promise((resolve, reject) => {
			instance.post((this.url), this.arg).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			});
		})
	}

	//get 
	get() {
		return new Promise((resolve, reject) => {
			instance.get((this.url)).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			});
		})
	}
	
	delete() {
		return new Promise((resolve, reject) => {
			instance.delete((this.url)).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			});
		})
	}
}

export default request